import { BaseCheckoutCardConfig } from '../checkout-card/base-checkout-card-config.interface';
import { WorldpayCustomisation } from './worldpay-customisation.interface';
import { WorldpayTransactionSource } from './worldpay-transaction-source.enum';
import { WorldpayTransactionType } from './worldpay-transaction-type.enum';

export interface WorldpayConfig extends BaseCheckoutCardConfig {
  customisation: WorldpayCustomisation;
  iframeHelperURL: string;
  transactionDescription: string;
  transactionSource: WorldpayTransactionSource;
  transactionType: WorldpayTransactionType;
}
